import React, { useContext, useState } from 'react';
import { Slider, Typography } from 'antd';
import { BsFuelPump } from 'react-icons/bs';
import AlertCard from './AlertCard';
import { ALERT_CATEGORY, triggerAlert } from '../../mqtt/aws';
import { SimulatorContext } from 'store/context';

const { Text } = Typography;

const LowFuelAlert = ({ messageApi, onTriggered }) => {
  const { stsToken: credentials, vehicleSimulatorSettings: { serialNo, vehicleKey } } = useContext(SimulatorContext);
  const [fuel, setFuel] = useState(20);
  const [loading, setLoading] = useState(false);

  const triggerFuelAlert = async () => {
    setLoading(true);
    await triggerAlert({ serialNo, vehicleKey, actual: fuel, threshold: 80 }, credentials, ALERT_CATEGORY.FUEL_ALERT)
      .then(() => { messageApi.success('Low fuel alert triggered successfully'); onTriggered?.({ success: true, value: `${fuel}%` }); })
      .catch(() => { messageApi.error('Failed to trigger low fuel alert'); onTriggered?.({ success: false, value: `${fuel}%` }); })
      .finally(() => setLoading(false));
  };

  return (
    <AlertCard
      index={11}
      title="Low Fuel"
      icon={<BsFuelPump />}
      iconBg="#fff7ed"
      iconColor="#f97316"
      threshold="30%"
      onTrigger={triggerFuelAlert}
      triggerLabel="Trigger Fuel Alert"
      loading={loading}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Text style={{ fontSize: 11, color: '#64748b' }}>Current fuel level</Text>
        <Text style={{ fontSize: 20, fontWeight: 700, color: fuel <= 30 ? '#ef4444' : '#0f172a', lineHeight: 1 }}>
          {fuel} <span style={{ fontSize: 12, fontWeight: 500, color: '#94a3b8' }}>%</span>
        </Text>
      </div>
      <Slider min={0} max={100} value={fuel} onChange={setFuel} />
    </AlertCard>
  );
};

export default LowFuelAlert;
